module.exports = __webpack_public_path__ + "static/media/envelope-2.b7cfd56d.svg";